/**
 * Category slug → Lucide icon name map (F-160 C2, R2 no-emoji).
 *
 * Mirrors `backend/fixtures/parent_categories.json` + `categories.json`. Keep
 * keys aligned with backend `catalog.Category.slug`. Values must exist in the
 * `MAP` exported from `components/atoms/Icon.tsx` — unknown slugs fall back
 * to the neutral "more" glyph rather than crashing the grid.
 */
import type { IconName } from '@/components/atoms/Icon';

export const CATEGORY_ICON_MAP: Record<string, IconName> = {
  // Parent buckets (g_*)
  g_home: 'home',
  g_beauty: 'sparkles',
  g_education: 'graduation-cap',
  g_legal_fin: 'scale',
  g_health: 'heart-pulse',
  g_transport: 'car',
  g_creative: 'laptop',
  g_events: 'party-popper',

  // Leaf categories
  repair: 'wrench',
  cleaning: 'brush',
  moving: 'truck',
  pets: 'paw-print',

  beauty: 'scissors',
  fitness: 'dumbbell',

  tutoring: 'book-open',
  music: 'music',
  translation: 'languages',

  legal: 'scale',
  accounting: 'calculator',

  medicine: 'stethoscope',
  psychology: 'brain',
  childcare: 'baby',

  auto: 'car',
  courier: 'package',

  it: 'laptop',
  design: 'palette',
  copy: 'pen-tool',
  photo_video: 'camera',

  weddings: 'gem',
  catering: 'chef-hat',
  flowers: 'flower',
  real_estate: 'building',
  other: 'more-horizontal',

  // Forward-compat aliases used in the F-160 spec text
  health: 'stethoscope',
  tech: 'laptop',
  events: 'party-popper',
  home: 'home',
  finance: 'banknote',
  kids: 'baby',
};

export function categoryIcon(slug: string): IconName {
  return CATEGORY_ICON_MAP[slug] ?? 'more-horizontal';
}
